import { Tag, type TagProps } from '../tag/index.ts'

export const FeedTag = ({ children, ...props }: TagProps) => {
  return (
    <Tag variant="primary" {...props}>
      {children}
    </Tag>
  )
}
